import {useMemo} from 'react'
import useContentAsset from './use-content-asset'

const useContentAssetConfig = (contentAssetId) => {
    const {data} = useContentAsset(contentAssetId)

    return useMemo(() => {
        try {
            if (!data?.contentAssetHTML) return {}

            const config =
                typeof data.contentAssetHTML === 'string'
                    ? JSON.parse(data.contentAssetHTML)
                    : data.contentAssetHTML

            return config && typeof config === 'object' && !Array.isArray(config) ? config : {}
        } catch {
            return {}
        }
    }, [data?.contentAssetHTML])
}

export default useContentAssetConfig
